import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import { EditProductView } from './ui/edit-product-view';
import { NewProductView } from './ui/new-product-view';

/**
 * 상품 등록 및 수정 — DRAFT 점진 저장 파이프라인.
 * 신규(/products/editor)는 기본 정보 완성 시 DRAFT 를 만들고 수정 화면으로 넘어간다.
 * 수정(/products/editor/:productId)은 섹션별로 저장한다.
 */
export const ProductEditorPage = (): ReactElement => {
  const { productId } = useParams<{ productId: string }>();

  return productId ? <EditProductView productId={productId} /> : <NewProductView />;
};
